import React, { useState } from 'react';
import DialogBox from 'components/dialog';
import { H5, P } from 'components/reusable-css';
import * as Styles from '../style';
import { Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import Input from 'components/input';
import CustomButton from 'components/common/custom-button';
import Checkbox from 'components/common/radio-button';

const CreateObject = ({
  label,
  setLabel,
  openFilter,
  handleClose,
  handleNameSubmit,
  isLoading,
  objType,
  setObjType,
}) => {
  const { t } = useTranslation();
  const [labelError, setLabelError] = useState(false);

  return (
    <DialogBox crossButton width="sm" open={openFilter} onClose={handleClose}>
      <Styles.RenameModal>
        <H5>{t('vs/firewall.string46')}</H5>
        <Styles.GreyBorder />
        <Styles.NewTag>
          <Input
            type="text"
            styling={{ fontSize: '16px', marginBottom: '0' }}
            focusName="firewall_object"
            name="firewall_object"
            value={label}
            tooltipStyles={{
              leftPosition: '8%',
              headingSize: '11px',
              descriptionSize: '11px',
              minWidth: '80%',
              bottomPosition: '65px',
              arrowSize: '18px',
            }}
            onChange={async (e) => {
              setLabel(e.target.value);
              const isValid = label.length == 0;
              setLabelError(isValid);
            }}
            loading={isLoading}
            inputProps={{
              maxlength: 64,
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleNameSubmit(label);
              }
            }}
            touched
            error={labelError ? 'vs/firewall.string17' : ''}
            placeholder={t('vs/firewall.string18')}
            isFormIk={false}
            EndAdornment={() => (
              <span onClick={() => handleNameSubmit(label)}>
                <Icon name="save" />
              </span>
            )}
          />
        </Styles.NewTag>
        <Styles.RadioPortCardContainer>
          <Styles.RadioPortCard onClick={() => setObjType('ipv4')}>
            <Checkbox
              checkbox={objType}
              setCheckedValue={(value) => setObjType(value)}
              data={{ id: 'ipv4' }}
              onClick={() => setObjType('ipv4')}
            />
            <P>{t('vs/firewall.string62')}</P>
          </Styles.RadioPortCard>
          <Styles.RadioPortCard onClick={() => setObjType('port')}>
            <Checkbox
              checkbox={objType}
              setCheckedValue={(value) => setObjType(value)}
              data={{ id: 'port' }}
              onClick={() => setObjType('port')}
            />
            <P>{t('vs/firewall.string63')}</P>
          </Styles.RadioPortCard>
        </Styles.RadioPortCardContainer>
        <Styles.ButtonContainer>
          <CustomButton
            disabled={isLoading || label.length == 0}
            title={'vs/firewall.string47'}
            isLoading={isLoading}
            onClick={() => handleNameSubmit(label)}
            rightIcon={<Icon name="angle left" />}
          />
        </Styles.ButtonContainer>
      </Styles.RenameModal>
    </DialogBox>
  );
};

export default CreateObject;
